<template>
	<div>
		<navigator :index="3"></navigator>
		<!-- <div class="navigationBg">
			<header class="navigation">
				<h1>
					<img class="logo" alt="筑橙科技" src="../resource/images/logo.svg">
				</h1>
				<nav class="navigator">
					<router-link to="/" class="navigatorText">首页
						<div class="block"></div>
					</router-link>
					<div @click="reminder()" class="navigatorText">产品中心
						<div class="block"></div>
					</div>
					<router-link to="/example01" class="navigatorText ">应用案例
						<div class="block "></div>
					</router-link>
					<router-link to="/news01" class="navigatorText">筑橙新闻
						<div class="block"></div>
					</router-link>
					<div class="navigatorText active">关于我们
						<div class="block activeBlock"></div>
					</div>
					<div @click="open()" class="navigatorText">在线联系
						<div class="block"></div>
					</div>
				</nav>
			</header>
		</div> -->
		<div class="localhost">
			<div class="localhostText">首页/<span style="color:#333;">关于我们</span></div>
		</div>
		<div class="example">
			<div class="exampleTitle">关于我们</div>
			<div class="exampleDate"></div>
			<div class="exampleItemDiv">
				<div class="exampleItem">
					<h3 class="exampleItemTitle" style="text-indent: 2em;">
						筑橙科技（深圳）有限公司（以下简称为“筑橙科技”）成立于2018年，是一家致力于用机器人技术推动产业革新，为建筑施工产业提供智能施工解决方案的高新技术企业。筑橙科技将人工智能、环境感知、深度学习、伺服控制等核心技术应用到建筑施工领域，自主开发多款建筑机器人产品，其中外墙智能喷涂机器人已经实现产业化应用
						，能够大幅降低高空作业中的安全风险，显著提高施工作业效率和品质；室内智能喷涂机器人已完成重大技术突破，可以实现全流程无人化智能施工。2020年在无锡蠡湖金茂府项目上筑橙科技实现了第一个外墙涂装机器商业化应用，同年获得国际顶级投资机构数千万的风险投资，成为建筑机器人领域的领导者。
					</h3>
					<div class="exampleImgList">
						<div class="exampleImg">
							<img style="width:100%;height:auto;display: block;"
								src="../resource/images/certificate/2.jpg" alt="荣获国家高新技术企业">
							<div class="hint">荣获国家高新技术企业</div>
						</div>
						<div class="exampleImg">
							<img style="width:565px;height:auto;display: block;margin:0 auto;"
								src="../resource/images/certificate/1.jpg" alt="已授权发明专利">
							<div class="hint">已授权发明专利</div>
						</div>
						<div class="exampleImg">
							<img style="width:565px;height:auto;display: block;margin:0 auto;"
								src="../resource/images/certificate/3.jpg" alt="已授权发明专利">
							<div class="hint">已授权发明专利</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="width:100%;overflow:hidden;">
			<div class="banner">
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in bannerList">
							<div style="position: relative;">
								<div class="swiperLayer"></div>
								<img class="swiper-slideImg" :src="item">
							</div>
						</div>
					</div>
					<div class="swiper-button-prev"></div>
					<div class="swiper-button-next"></div>
					<div class="swiper-pagination"></div>
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	/*
		需要npm install swiper@3 --save-dev 这个框架
	*/
	import 'swiper/dist/css/swiper.min.css'
	import 'swiper/dist/js/swiper.min'
	import Swiper from 'swiper'
	import foot from "../components/foot"
	import navigator from "../components/navigator"
	export default {
		components: {
			foot,
			navigator
		},
		name: 'absoutUs',
		data() {
			return {
				bannerList: []
			}
		},
		methods: {
			open(){
				window.open("http://qingflow.com/f/a445638c?qfchannel=Website")
				// window.location.href = "http://qingflow.com/f/a445638c?qfchannel=Website"
			},
			reminder() {
				this.hint.hint()
			}
		},
		mounted() {
			for (let i = 1; i <= 19; i++) {
				this.bannerList.push(require(`../resource/images/certificate/banner/${i}.jpg`))
			}

			this.$nextTick(() => {
				new Swiper('.swiper-container', {
					effect: 'coverflow', //启用coverflow切换特效
					prevButton: '.swiper-button-prev', //左右箭头点击切换
					nextButton: '.swiper-button-next',
					slidesPerView: 2.2,
					initialSlide: 1,
					centeredSlides: true,
					coverflow: {
						rotate: 0,
						stretch: 20,
						depth: 180,
						modifier: 2,
						slideShadows: false
					},
					loop: false,
					// slidesOffsetAfter: 2,
					spaceBetween: 0,
					// updateOnImagesReady: true,
					// observer: true, //修改swiper自己或子元素时，自动初始化swiper
					// observeParents: true, //修改swiper的父元素时，自动初始化swipe
					paginationType: 'progress',
					pagination: '.swiper-pagination',
					paginationType: 'custom',
					paginationCustomRender: function(swiper, current, total) {
						return `<div style="font-size:20px;font-weight:700;color:#333;">其他专利<span style="margin-left:20px;">${current}/${total}</span></div>`
					}
				})
			})
		}
	}
</script>

<style scoped>
	.swiper-slide img{
		display: none;
	}
	.swiper-slide-active img, .swiper-slide-prev img, .swiper-slide-next img{
		display: block !important;
	}
	.swiper-container {
		overflow: inherit;
		padding-bottom: 35px;
	}

	.swiper-pagination-custom {
		bottom: -15px !important;
	}

	.swiper-button-prev,
	.swiper-button-next {
		width: 62px;
		height: 104px;
		background-size: 62px 104px;
		transform: scale(.7);
	}

	.swiper-button-prev {
		background-image: url(../resource/images/left.png);
	}

	.swiper-button-next {
		background-image: url(../resource/images/right.png);
	}

	.swiper-slide-prev .swiperLayer,
	.swiper-slide-next .swiperLayer {
		/* display: none; */
		width: 559px;
		height: 799px;
		position: absolute;
		left: 0;
		top: 0;
		background-color: rgba(0, 0, 0, .3);
	}

	.swiper-slide-active .swiper-slideImg {
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.16);
	}

	.swiper-slideImg {
		/* width: 757px; */
		width: 559px;
		height: auto;
		display: block;
	}

	.swiper-slide {
		position: relative;
	}

	.banner {
		/* overflow:hidden; */
		width: 1220px;
		/* width: 942px; */
		margin: 80px auto 100px;
		padding-bottom: 45px;
	}

	.line {
		width: 1045px;
		height: 2px;
		background-color: #194c7f;
		margin: 49px auto 50px auto;
		border-radius: 2px;
	}

	.next {
		display: block;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
		line-height: 12px;
		letter-spacing: 0.58px;
		margin-top: 10px;
		margin-bottom: 100px;
		transition: all .3s;
	}

	.previous {
		display: block;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999999;
		line-height: 12px;
		letter-spacing: 0.58px;
	}

	.next:hover {
		color: #194c7f;
	}

	.lastHint {
		text-indent: 2em;
		margin: 50px auto;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		/* color: #707070; */
		color: #666;
		line-height: 26px;
		letter-spacing: 0.77px;
	}

	.exampleItemTitle {
		margin-top: 50px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #707070;
		line-height: 26px;
		letter-spacing: 0.77px;
		margin-bottom: 30px;
	}

	.hint {
		display: block;
		margin-bottom: 20px;
		margin-top: 15px;
		line-height: 28px;
		font-size: 20px;
		font-weight: 700;
		text-align: center;
		color: #333;
	}

	.exampleImgList {
		/* display: flex;
		justify-content: space-around; */
	}

	.exampleImg {
		/* margin-right: 45px; */
		width: 1020px;
		margin: 0 auto;
	}

	.exampleImg:nth-last-child(1) {
		margin-right: 0;
	}

	.exampleDate {
		/* margin-top: 30px; */
		/* line-height: 22px; */
		/* font-size: 16px; */
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #bbb;
		padding-bottom: 30px;
		box-sizing: border-box;
		border-bottom: 1px solid #eee;
	}

	.example {
		width: 1040px;
		margin: 0 auto;
		overflow: hidden;
	}

	.exampleTitle {
		margin-top: 70px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
	}

	.localhostText {
		width: 1040px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
		margin: 0 auto;
	}

	.localhost {
		height: 85px;
		display: flex;
		align-items: center;
		background-color: #f6f7f7;
	}

	.localhostText {
		width: 1200px;
		margin: 0 auto;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
	}

	.title {
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Heavy;
		font-weight: 800;
		text-align: left;
		color: #333;
		margin-top: 60px;
	}

	.logo {
		width: 154px;
		height: 38px;
	}

	.navigation {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navigator {
		display: flex;
		align-items: center;
	}

	.navigatorText {
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fff;
		margin-left: 60px;
		cursor: pointer;
		transition: all .3s;
		position: relative;
	}

	.navigatorText:nth-child(1) {
		margin-left: 0px;
	}

	.navigatorText:hover {
		color: #EA5B24;
	}

	.block {
		position: absolute;
		/* width: 33px; */
		width: 100%;
		height: 2px;
		background-color: #fff;
		transition: all .3s;
		left: 0;
		bottom: -5px;
		opacity: 0;
	}

	.navigatorText:hover .block {
		background-color: #EA5B24;
		opacity: 1;
	}

	.navigationBg {
		width: 100%;
		background-color: rgba(0, 0, 0, 0.66);
		display: flex;
		justify-content: center;
		/* position: absolute;
		left: 0;
		top: 0; */
	}

	.navigatorText {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue